import { ApolloClient, ApolloLink, from as linkFrom } from '@apollo/client'
import { hasWindow } from '@obeta/utils/lib/ssr'
import { AppActions } from '@obeta/models/lib/models/BusinessLayer/AppActions'
import { getInMemoryCache } from './getInMemoryCache'
import { RxDatabase } from 'rxdb'
import { getErrorLink } from './getErrorLink'
import getDefaultEndpoint from './endpoints/default'
import getStrapiEndpoint from './endpoints/strapi'

export const initApollo = (appActions: AppActions, db: RxDatabase) => {
  const errorLink = getErrorLink({ appActions })

  const defaultEndpoint = getDefaultEndpoint({
    appActions,
    db,
  })

  const strapiEndpoint = getStrapiEndpoint({
    appActions,
  })

  const endpoints = ApolloLink.split(
    (operation) => operation.getContext().endpoint === 'strapi',
    strapiEndpoint,
    defaultEndpoint
  )

  const links = [errorLink, endpoints]

  return new ApolloClient({
    ssrMode: !hasWindow(), // set to true for SSR
    link: linkFrom(links),
    cache: getInMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
      },
      watchQuery: {
        fetchPolicy: 'no-cache',
      },
    },
  })
}
